import * as React from "react";
const SvgCircle = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12,9c-1.6569,0-3,1.3431-3,3s1.3431,3,3,3,3-1.3431,3-3-1.3431-3-3-3Z" }));
export default SvgCircle;
